import { Component, OnDestroy, OnInit } from '@angular/core';
import { BaseListComponent } from 'src/app/base/components/base-list.component';
import { OrgaoSetorialista } from '../../models/orgao-setorialista.model';
import { NavigationService } from '../../services/navigation.service';
import { OrgaoSetorialistaService } from '../../services/orgao-setorialista.service';

@Component({
  selector: 'app-orgao-setorialista-list',
  templateUrl: './orgao-setorialista-list.component.html',
  styleUrls: ['./orgao-setorialista-list.component.scss']
})
export class OrgaoSetorialistaListComponent extends BaseListComponent<OrgaoSetorialista> implements OnInit, OnDestroy {

  orgaoList: OrgaoSetorialista[];

  constructor(
    private myService: OrgaoSetorialistaService,
    private navigation: NavigationService
  ) {
    super();
  }

  ngOnInit() {
    this.initLoadDataTable();
  }

  ngOnDestroy(): void {
    this.unsubscribeList();
  }

  initLoadDataTable() {
    this.addSub(
      this.myService.findAll().subscribe((res) => {
        this.orgaoList = res;
        this.loaded();
      })
    );
  }

  novo() {
    return ['/projetos/admin-spgg/orgao-setorialista/adicionar'];
  }

  confirmExcluir(id: number) {
    this.alertConfirmation(id).subscribe((confirmed) => {
      if (confirmed) {
        this.excluir(id);
      }
    });
  }

  excluir(id: any): void {
    this.loading();
    this.myService.delete(id).subscribe({
      next: (res) => {
        this.initLoadDataTable();
        this.msgSuccess();
      },
      error: (error) => {
        this.loaded();
        this.msgError(error?.error.message)
      }
    });
  }

  editar(id: number) {
    return ['/projetos/admin-spgg/orgao-setorialista/', id];
  }
}
